export default __webpack_public_path__ + "static/media/people.cf34ae1e.svg";